import styled from "styled-components";
import { styles } from "../../GlobalStyle";

export const StyledDataRow = styled.div`
  padding-top: ${styles.spacing.verySmall}px;
`;
